<template>
    <div class="chartColumn chart_left">
        <div v-for="item in getHeaderList" :key="item.value" :class="`chart${item.key}`">{{ item.value }}</div>
    </div>
</template>

<script>
import { HEADER_LIST } from "@/components/Fleet/WorkOrdersStatistics/StatisticsChart/ChartHeader/constants";

export default {
	name: "ChartHeader",
	computed: {
		getHeaderList() {
			return HEADER_LIST;
		}
	}
};
</script>

<style scoped lang="scss">
.chart {
    &Column {
        display: grid;
        grid-template-rows: repeat(8, 60px);
    }

    &_left {
        text-align: center;
    }

    &Td {
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: inset -2px 0px 0px #8F90A6, inset -1px -1px 0px #40404B;
    }

    &Head {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        box-shadow: inset -2px 0px 0px #8F90A6, inset -1px -1px 0px #40404B;
        color: #71CC82;
        font-size: 14px;
        border-bottom: 1px solid #1B442C;
    }
}
</style>
